import React from "react";
import { ArrowLeft } from "lucide-react";

const VehicleFareLeftPanel = ({
  onBack,
  formData,

  selectedVehicleData,
  fare,

  payAt,
  setPayAt,

  showPayment,
  handleBookParcel,
}) => {
  return (
    <div className="order-2 flex w-full flex-col bg-white px-4 py-5 sm:px-6 md:px-8 lg:order-1 lg:px-7">
      <div className="mx-auto w-full max-w-[580px]">
          {/* BACK */}
                <button
                  type="button"
                  onClick={onBack}
                  className="hidden lg:inline-flex mb-3 items-center gap-2 rounded-2xl border border-slate-200 bg-white px-4 py-2 text-sm font-bold text-slate-700 transition hover:bg-slate-50"
                >
                  <ArrowLeft size={17} />
                  Back
                </button>

        {/* CONTACT INFO */}
        <div className="mb-4 overflow-hidden rounded-lg border border-gray-200 bg-white">
          <h3 className="border-b px-4 py-3 text-[18px] text-gray-800">
            Contact Details
          </h3>

          <div className="grid grid-cols-2 gap-4 px-4 py-4 text-sm">
            <div>
              <p className="text-gray-400">Sender</p>
              <p className="font-semibold text-gray-800">
                {formData?.senderName || "-"}
              </p>
              <p className="text-gray-500">
                {formData?.senderMobile || "-"}
              </p>
            </div>

            <div>
              <p className="text-gray-400">Receiver</p>
              <p className="font-semibold text-gray-800">
                {formData?.receiverName || "-"}
              </p>
              <p className="text-gray-500">
                {formData?.receiverMobile || "-"}
              </p>
            </div>
          </div>
        </div>

        {/* FARE SUMMARY */}
        <div className="mb-4 overflow-hidden rounded-lg border border-gray-200 bg-white">
          <h3 className="border-b px-4 py-3 text-[18px] text-gray-800">
            Fare Summary
          </h3>

          <div className="space-y-3 px-4 py-4 text-sm">
            <div className="flex flex-wrap items-start justify-between gap-2">
              <span className="text-gray-500">Selected Vehicle</span>
              <span className="font-bold text-gray-800">
                {selectedVehicleData?.name}
              </span>
            </div>

            <div className="flex flex-wrap items-start justify-between gap-2">
              <span className="text-gray-500">Trip Fare</span>
              <span className="font-bold text-gray-800">
                ₹ {fare.tripFare.toFixed(2)}
              </span>
            </div>

            <div className="flex flex-wrap items-start justify-between gap-2">
              <span className="text-gray-500">
                Toll Charges
                <span className="ml-1 rounded-full bg-orange-100 px-1.5 py-0.5 text-[9px] text-orange-500">
                  include
                </span>
              </span>

              <span className="font-bold text-gray-800">
                ₹ {fare.tollCharges.toFixed(2)}
              </span>
            </div>

            <div className="flex flex-wrap items-start justify-between gap-2">
              <span className="text-gray-500">Net Fare</span>
              <span className="font-bold text-gray-800">
                ₹ {fare.netFare.toFixed(2)}
              </span>
            </div>

            <div className="flex justify-between border-t py-2">
              <span className="font-bold text-gray-500">Amount Payable</span>
              <span className="font-bold text-gray-800">
                ₹ {fare.amountPayable.toFixed(2)}
              </span>
            </div>
          </div>
        </div>

        {/* PAYMENT */}
        <div className="mb-6 overflow-hidden rounded-lg border border-gray-200 bg-white">
          <div className="border-b px-4 py-3">
            <h3 className="text-[18px] font-semibold text-gray-800">
              Select Payment Mode
            </h3>
          </div>

          <button className="flex w-full flex-col items-start gap-1 px-4 py-3 hover:bg-gray-50 sm:flex-row sm:items-center sm:justify-between">
            <span className="font-medium text-gray-700">UPI</span>
            <span className="text-sm text-gray-400">
              Google Pay / PhonePe
            </span>
          </button>

         <button className="flex w-full flex-col items-start gap-1 border-t px-4 py-3 hover:bg-gray-50 sm:flex-row sm:items-center sm:justify-between">
            <span className="font-medium text-gray-700">
              Cash on Delivery
            </span>
            <span className="text-sm text-gray-400">Pay after delivery</span>
          </button>

        <button className="flex w-full flex-col items-start gap-1 border-t px-4 py-3 hover:bg-gray-50 sm:flex-row sm:items-center sm:justify-between">
            <span className="font-medium text-gray-700">
              Debit / Credit Card
            </span>
            <span className="text-sm text-gray-400">Visa, Mastercard</span>
          </button>
        </div>
      </div>

      {/* Pay At Toggle */}
     <div className="mx-auto w-full max-w-[580px]">
  <div className="mb-6 flex flex-col gap-3 rounded-lg border border-gray-200 bg-white px-4 py-3 sm:flex-row sm:items-center sm:justify-between">
        <span className="text-[16px] font-semibold text-gray-800">
          Pay At
        </span>

        <div className="grid w-full grid-cols-2 rounded-full bg-gray-100 p-1 sm:flex sm:w-auto">
          <button
            type="button"
            onClick={() => setPayAt("Pick Up")}
            className={`flex-1 rounded-full px-3 py-2 text-sm font-medium transition sm:flex-none sm:px-4 ${
              payAt === "Pick Up"
                ? "bg-white text-gray-800 shadow"
                : "text-gray-500 hover:text-gray-800"
            }`}
          >
            Pick Up
          </button>

          <button
            type="button"
            onClick={() => setPayAt("Drop")}
            className={`flex-1 rounded-full px-3 py-2 text-sm font-medium transition sm:flex-none sm:px-4 ${
              payAt === "Drop"
                ? "bg-white text-gray-800 shadow"
                : "text-gray-500 hover:text-gray-800"
            }`}
          >
            Drop
          </button>
        </div>
      </div>
      </div>

      {/* BOTTOM BUTTON */}
     <div
  className={`mx-auto w-full max-w-[580px] transition-all duration-300 ${
    showPayment ? "mt-0" : "mt-2"
  }`}
>
        <button



          type="button"
          onClick={handleBookParcel}
          className="w-full rounded-lg bg-[#2563eb] py-3 text-sm font-semibold text-white transition hover:opacity-90 sm:text-base"
        >
          Driver is on the Way
        </button>
      </div>
    </div>
  );
};

export default VehicleFareLeftPanel;
